import { createContext } from 'react';

export const RoadMapContext = createContext<{
  roadMapId: string;
}>({ roadMapId: '' });
